import Box from "@mui/material/Box";
import { useTranslationApp } from "../../lib/i18next";
import TitlePage from "../Texts/TitlePage";
import { usePlanType, getPricingHeroTitle } from "./plansConfiguration";

const PricingHero = () => {
  const { t } = useTranslationApp();
  const { currentTypeOfPlan, isTypeOfPlansLoaded } = usePlanType();

  if (!isTypeOfPlansLoaded) {
    return null;
  }

  return (
    <Box
      sx={{
        pt: 4,
        pb: 4,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        px: {
          md: 4,
          xs: 3,
        },
        background: "background.paper",
      }}
    >
      <Box
        sx={{
          maxWidth: "md",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          mt: 2,
        }}
      >
        <TitlePage
          align="center"
          sx={{
            color: "background.paperContrastText",
          }}
        >
          {getPricingHeroTitle(currentTypeOfPlan, t)}
        </TitlePage>
      </Box>
    </Box>
  );
};

export default PricingHero;
